import { render, staticRenderFns } from "./BigStat.vue?vue&type=template&id=4250248a&scoped=true"
import script from "./BigStat.vue?vue&type=script&lang=js"
export * from "./BigStat.vue?vue&type=script&lang=js"
import style0 from "./BigStat.scss?vue&type=style&index=0&id=4250248a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250248a",
  null
  
)

export default component.exports